/*
  Montrelio (refonte panier) : comportements du résumé de panier.

  ⚠️ Ce code vivait auparavant dans un <script> inline à l'intérieur de
  snippets/cart-summary.liquid. Quand le panier passait de vide à non vide, le
  résumé était réinjecté par le morph du thème : un <script> inséré ainsi n'est
  JAMAIS exécuté par le navigateur. Les dates de livraison restaient donc vides
  et la puce ETE10 n'avait aucun gestionnaire de clic (bug visible surtout dans
  le tiroir panier). Le fichier est désormais chargé globalement via
  snippets/scripts.liquid, et tout passe par de la délégation d'évènements +
  un MutationObserver pour survivre aux réinjections.
*/
(function () {
  if (window.__mcartSummaryInit) return;
  window.__mcartSummaryInit = true;

  function mtrack(ev, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev };
      Object.keys(params || {}).forEach(function (k) { o[k] = params[k]; });
      window.dataLayer.push(o);
      if (typeof window.gtag === 'function') window.gtag('event', ev, params || {});
    } catch (e) {}
  }

  /* ---- Délai daté : même fenêtre que la fiche produit (J+6 à J+12 ouvrés, cut-off 17 h Paris) ---- */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function fmtDate(d) {
    try {
      return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
    } catch (e) { return d.toLocaleDateString(); }
  }

  function fillDelivery() {
    var blocks = document.querySelectorAll('[data-mcart-delivery]');
    if (!blocks.length) return;
    var parisHour = 17;
    try {
      parisHour = parseInt(new Intl.DateTimeFormat('fr-FR', { hour: 'numeric', hour12: false, timeZone: 'Europe/Paris' }).format(new Date()), 10);
    } catch (e) {}
    var offset = parisHour >= 17 ? 1 : 0;
    var d1 = fmtDate(addBusinessDays(new Date(), 6 + offset));
    var d2 = fmtDate(addBusinessDays(new Date(), 12 + offset));
    blocks.forEach(function (b) {
      var e1 = b.querySelector('[data-mcart-d1]');
      var e2 = b.querySelector('[data-mcart-d2]');
      if (e1 && e1.textContent !== d1) e1.textContent = d1;
      if (e2 && e2.textContent !== d2) e2.textContent = d2;
    });
  }

  /* Le résumé est morphé à chaque mise à jour du panier : on re-remplit dès qu'un
     placeholder vide réapparaît (observer débouncé, coût négligeable). */
  var refillTimer = null;
  /* ---- Urgence de l'offre : décompte jusqu'à l'échéance (08.08.2026) ----
     L'échéance est portée par l'attribut data-deadline du bloc, calculée en Liquid
     par snippets/montrelio-promo-deadline.liquid — la même source que la barre
     d'annonce, donc jamais deux dates différentes sur le site.
     Un seul intervalle pour toute la page, quel que soit le nombre de paniers
     rendus (page /cart + tiroir), et il s'arrête de lui-même à l'échéance. */
  var cdTimer = null;

  function renderCountdown() {
    var blocks = document.querySelectorAll('[data-mcart-urgence]');
    if (!blocks.length) return false;
    var alive = false;
    blocks.forEach(function (b) {
      var iso = b.getAttribute('data-deadline');
      if (!iso) return;
      /* montrelio-promo-deadline rend déjà un ISO complet avec fuseau
         (2026-08-09T23:59:59+02:00). On ne complète que si la date est nue,
         sinon on fabrique une chaîne invalide et le bloc reste masqué. */
      var end = new Date(iso.indexOf('T') === -1 ? iso + 'T23:59:59' : iso);
      var ms = end.getTime() - Date.now();
      if (isNaN(ms) || ms <= 0) { b.hidden = true; return; }
      alive = true;
      b.hidden = false;
      var out = b.querySelector('[data-mcart-cd]');
      if (!out) return;
      var totalMin = Math.floor(ms / 60000);
      var d = Math.floor(totalMin / 1440);
      var h = Math.floor((totalMin % 1440) / 60);
      var m = totalMin % 60;
      var txt;
      if (d > 0) txt = '· plus que ' + d + ' j ' + h + ' h';
      else if (h > 0) txt = '· plus que ' + h + ' h ' + (m < 10 ? '0' : '') + m + ' min';
      else txt = '· plus que ' + m + ' min';
      if (out.textContent !== txt) out.textContent = txt;
    });
    return alive;
  }

  function startCountdown() {
    if (cdTimer) return;
    if (!renderCountdown()) return;
    cdTimer = setInterval(function () {
      if (!renderCountdown()) { clearInterval(cdTimer); cdTimer = null; }
    }, 30000);
  }

  function scheduleRefill() {
    if (refillTimer) return;
    refillTimer = setTimeout(function () {
      refillTimer = null;
      fillDelivery();
      startCountdown();
    }, 150);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    fillDelivery();
    startCountdown();
    try {
      new MutationObserver(scheduleRefill).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  });

  /* La puce « appliquer le code promo » a été retirée le 07.08.2026 : la remise de 20 % est
     désormais portée par le prix barré de chaque produit. Plus de code à saisir, donc plus
     de gestionnaire de clic ni d'événement GA4 cart_promo_apply. */

  /* ---- Tracking délégué (page + drawer) : clic Commander, retrait d'article ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var checkout = t.closest('.cart__checkout-button');
    if (checkout) {
      var value = 0;
      try {
        var el = document.querySelector('[data-testid="cart-total-value"]');
        if (el) value = parseFloat(el.textContent.replace(/[^0-9,.]/g, '').replace(',', '.')) || 0;
      } catch (err) {}
      mtrack('cart_checkout_click', { currency: 'EUR', value: value });
      return;
    }

    var remove = t.closest('.cart-items__remove');
    if (remove) {
      var row = remove.closest('tr');
      var title = row && row.querySelector('.cart-items__title');
      mtrack('cart_remove', { item_name: title ? title.textContent.trim() : '' });
    }
  }, true);
})();
